import React from 'react';
import GenericInternalTransfer from '../GenericInternalTransfer';

const SalesReturnInternalTransfer = () => (
  <GenericInternalTransfer
    sectionName="Sales Return Section"
    sectionKey="Sales Return"
    backRoute="/sections/sales-return"
  />
);

export default SalesReturnInternalTransfer;
